<template>
  <div id="management-objectives" class="mb-5">
    <ReportHeader
      :reportTypeId="reportTypeId"
      :title="title"
      :subtitle="subtitle"
    />

    <div class="row">
      <div class="col-xxx-large-3 col-x-large-6 pb-3">
        <label class="m-0 managementLabel p-3" style="background: #0000ff">
          Phase A
        </label>
        <div class="py-3 managementPhase phaseAList">
          <div class="px-3">
            <div class="row pb-3">
              <div class="col">
                <h3
                  class="managementLabel"
                  style="color: #17355c; font-size: 16px"
                >
                  <img
                    src="\images\phase-a.png"
                    width="50"
                    height="50"
                    style="vertical-align: middle; margin-right: 1em"
                  />
                  Recovery
                </h3>
              </div>
            </div>
            <ul class="moPhaseAList">
              <li>Scrupulously evaluate the supply chain</li>
              <li>Model positive leadership (culture turns to behavior)</li>
              <li>
                Start to phase out marginal opportunities (products, processes,
                people); repair margins
              </li>
              <li>Perform due diligence on customers and extend credit</li>
              <li>
                Be on good terms with a banker; you will need the cash more now
                than in any other phase
              </li>
              <li>
                Invest in customer market research; know what they value and
                market/price accordingly
              </li>
              <li>
                Hire key people and implement company-wide training programs
                ahead of Phase B
              </li>
              <li>Allocate additional resources to sales and marketing</li>
              <li>Invest in system/process efficiencies</li>
              <li>
                Make opportunistic capital and business acquisitions; use
                pessimism to your advantage
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-xxx-large-3 col-x-large-6 pb-3">
        <label class="m-0 managementLabel p-3" style="background: #088408">
          Phase B
        </label>
        <div class="py-3 managementPhase phaseBList">
          <div class="px-3">
            <div class="row pb-3">
              <div class="col">
                <h3
                  class="managementLabel"
                  style="color: #17355c; font-size: 16px"
                >
                  <img
                    src="\images\phase-b.png"
                    width="50"
                    height="50"
                    style="vertical-align: middle; margin-right: 1em"
                  />
                  Accelerating Growth
                </h3>
              </div>
            </div>
            <ul class="moPhaseBList">
              <li>Ensure quality control keeps pace with increasing volume</li>
              <li>
                Invest in workforce development: hiring, training, retention
              </li>
              <li>
                Ensure you have the right price escalator; space out price
                increases
              </li>
              <li>
                Maximize your profit margins through differentiation; stand out
                from the crowd and set yourself apart
              </li>
              <li>
                Use improved cash flow to strategically position the business to
                beat the business cycle
              </li>
              <li>Expand credit to customers</li>
              <li>
                Improve corporate governance (rent a CFO; establish a board of
                advisors or board of directors)
              </li>
              <li>Communicate competitive advantages; build the brand</li>
              <li>
                Query users for what they want and what is important to them
              </li>
              <li>Sell the business in a climate of maximum goodwill</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-xxx-large-3 col-x-large-6 pb-3">
        <label class="m-0 managementLabel p-3" style="background: #ff9900">
          Phase C
        </label>
        <div class="py-3 managementPhase phaseCList">
          <div class="px-3">
            <div class="row pb-3">
              <div class="col">
                <h3
                  class="managementLabel"
                  style="color: #17355c; font-size: 16px"
                >
                  <img
                    src="\images\phase-c.png"
                    width="50"
                    height="50"
                    style="vertical-align: middle; margin-right: 1em"
                  />
                  Slowing Growth
                </h3>
              </div>
            </div>
            <ul class="moPhaseCList">
              <li>
                Know if your markets are headed for a soft landing or a hard
                landing
              </li>
              <li>Cash is king; beware of unwarranted optimism</li>
              <li>Stay on top of aging receivables</li>
              <li>Revisit capital expenditure plans</li>
              <li>
                Lose the losers: if established business segments are not
                profitable during this phase, eliminate them
              </li>
              <li>
                Use competitive pricing to manage your backlog through the
                coming slowdown
              </li>
              <li>
                Avoid committing yourself to long-term expenses at the top of
                the price cycle, but lock in revenue
              </li>
              <li>Go entrepreneurial and/or counter-cyclical</li>
              <li>
                Evaluate your vendors for financial strength; if needed, look
                for additional vendors as a safety net
              </li>
              <li>
                If the cycle looks recessionary, cross-train key people to
                prepare for workforce attrition/reduction
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-xxx-large-3 col-x-large-6 pb-3">
        <label class="m-0 managementLabel p-3" style="background: #ff0000">
          Phase D
        </label>
        <div class="py-3 managementPhase phaseDList">
          <div class="px-3">
            <div class="row pb-3">
              <div class="col">
                <h3
                  class="managementLabel"
                  style="color: #17355c; font-size: 16px"
                >
                  <img
                    src="\images\phase-d.png"
                    width="50"
                    height="50"
                    style="vertical-align: middle; margin-right: 1em"
                  />
                  Recession
                </h3>
              </div>
            </div>
            <ul class="moPhaseDList">
              <li>Implement aggressive cost-cutting measures</li>
              <li>Offer alternative products with a lower cost basis</li>
              <li>
                Perform due diligence on acquisitions while valuations are
                falling
              </li>
              <li>
                Reduce advertising as consumers become more price conscious
              </li>
              <li>Enter or renegotiate long-term leases</li>
              <li>Negotiate labor contracts</li>
              <li>Consider capital equipment needs for the next cycle</li>
              <li>Tighten credit policies</li>
              <li>
                Develop programs for advertising, training, and marketing to
                implement in Phase A
              </li>
              <li>Lead with optimism, remembering that Phase D is temporary</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ReportHeader from '~/components/report/ReportHeader.vue';
  export default {
    name: 'ManagementObjectiveComponent',
    components: {
      ReportHeader,
    },
    props: {
      reportTypeId: {
        type: [String, Number],
        // required: true,
      },
    },
    computed: {
      title() {
        return `Management Objectives&#8482;`;
      },
      subtitle() {
        return ``;
      },
    },
  };
</script>
